import { render } from "./Contact.vue?vue&type=template&id=f02f1138"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=f02f1138&lang=css"

import exportComponent from "/codebuild/output/src515844760/src/osteopath-uk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__